/*
 * «Контроль», 005 (макет 6): ответственные пункта с адресатом в боковой панели, форма почты,
 * фильтр «Ответственный». Только токены «Табеля»; классы приложения — с префиксом kp-.
 */

/* Ответственные: список с рамкой, строка — имя и бейдж, пояснение, действия. */
.kp-resps {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--color-line);
  border-radius: var(--radius-card);
}
.kp-resp {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-3);
  font-size: 13px;
  overflow-wrap: anywhere;
}
.kp-resp + .kp-resp {
  border-top: 1px solid var(--color-line);
}
.kp-resp:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}
.kp-resp-h {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}
.kp-resp-name {
  min-width: 0;
}
.kp-resp-note {
  font-size: 12px;
}
.kp-resp-acts {
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-1);
}
.kp-resp-acts:empty {
  display: none;
}
.kp-resp-total {
  margin: var(--space-2) 0 0;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-control);
  background: var(--color-subtle);
  font-size: 13px;
}

/* Форма почты: поле на всю ширину, кнопки справа — «Отмена», затем «Сохранить почту». */
.kp-email-form {
  align-items: stretch;
  gap: var(--space-2);
  margin-top: var(--space-1);
}
/* Поле в столбце — по своей высоте (у t-field в строке формы — основа 240 px). */
.kp-email-form > .t-field {
  flex: none;
}
.kp-email-actions {
  align-self: stretch;
  justify-content: flex-end;
  gap: var(--space-2);
}

/* Фильтр «Ответственный»: поиск и варианты под ним. */
.kp-resp-filter {
  width: 22rem;
  max-width: calc(100vw - 2 * var(--space-4));
}
.kp-resp-options {
  max-height: 16rem;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}
.kp-resp-options:empty {
  display: none;
}
.kp-resp-option {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  width: 100%;
  min-height: var(--size-row);
  padding: var(--space-1) var(--space-2);
  border: 0;
  border-radius: var(--radius-control);
  background: none;
  color: var(--color-ink);
  font: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 120ms;
}
.kp-resp-option:hover,
.kp-resp-option[aria-current='true'] {
  background: var(--color-subtle);
}
.kp-resp-option:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}
.kp-resp-hint {
  margin: 0;
  font-size: 12px;
}

@media (prefers-reduced-motion: reduce) {
  .kp-resp-option {
    transition: none;
  }
}

/*
 * «Закрыто · отметка» (010, FR-048): текст ячейки с отметкой — в подсказке; пометка получает фокус,
 * чтобы подсказка открывалась и с клавиатуры.
 */
.kp-tip-badge {
  display: inline-flex;
  border-radius: var(--radius-full);
}
.kp-tip-badge:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/*
 * 047 (DNS-01; research Р1): «Без цвета» и «Без цвета · пауза» — тихий бейдж. Заливка color-subtle,
 * подпись color-ink-2 и значок нейтрального t-badge остаются (конституция, «Статусы на экране»);
 * обводки нет. Отступление от оформления t-badge «Табеля» (правило без пометки; plan.md 047,
 * Complexity Tracking): среди десятков серых пилюль с рамкой «Красный» терялся.
 */
.t-badge.kp-badge-quiet {
  box-shadow: none;
}

/* «Открыть в таблице» у пункта протокола в режиме ведения (014, FR-004): под текстом пункта. */
.kp-control-drawer-acts {
  margin: calc(-1 * var(--space-2)) 0 var(--space-4);
}

/*
 * 046 (T024; PHN-08, PHN-19, PHN-22; plan.md, «Раскладка на 360 × 780»): до 640 px над списком
 * одна строка — поиск и «Фильтры» (phone-filters.tsx), без переноса: поле сжимается, кнопка —
 * своей ширины. Лента включённых условий — под строкой поиска, внутри карточки списка, с той же
 * линией снизу, что у панели; прокручивается вбок внутри себя (phone-filters.css). Шире 640 px
 * правил нет: панель «Контроля» как раньше.
 */
@media (width <= 640px) {
  .t-toolbar.kp-control-phone-bar {
    flex-wrap: nowrap;
    gap: var(--space-2);
  }
  .kp-control-phone-bar > .kp-toolbar-search.kp-control-search {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
  }
  /* Поле — вровень с «Фильтры» и не ниже цели касания (MUST ux.md, § 15). */
  .kp-control-phone-bar > .kp-toolbar-search .t-input {
    height: var(--size-tap);
  }
  .kp-control-board > .kp-phone-chips {
    margin: 0;
    padding: var(--space-2) var(--space-3);
    border-bottom: 1px solid var(--color-line);
  }
}
